import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { fetchAllTicketsAPI, fetchRatedTicketsAPI } from '../services/serverService';
import { FaArrowLeft, FaSpinner } from 'react-icons/fa';

export default function SupportMetricDetail() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const type = searchParams.get('type');
    
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadMetricData = async () => {
            try {
                if (type === 'csat') {
                    const res = await fetchRatedTicketsAPI();
                    const ratedTickets = res.data?.data || [];
                    setTickets(ratedTickets);
                } else {
                    const res = await fetchAllTicketsAPI();
                    const allTickets = res.data?.data || [];
                    setTickets(allTickets);
                }
            } catch (err) {
                console.error("Failed to load metric data", err);
            } finally {
                setLoading(false);
            }
        };
        
        loadMetricData();
    }, [type]);

    if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><FaSpinner className="fa-spin" style={{ color: '#3182ce', fontSize: '24px' }}/></div>;

    return (
        <div style={{ padding: '30px', backgroundColor: '#f4f7fa', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <button 
                onClick={() => navigate('/admin/support-analytics')}
                style={{ background: 'none', border: 'none', color: '#4a5568', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '20px', fontWeight: 'bold' }}
            >
                <FaArrowLeft /> Back to Analytics
            </button>

            <h1 style={{ margin: '0 0 5px 0', color: '#2d3748', fontSize: '24px' }}>
                {type === 'csat' ? 'Customer Satisfaction Ratings' : 'Metric Details'}
            </h1>
            <p style={{ margin: '0 0 20px 0', color: '#718096' }}>Click on a ticket to view the full conversation and audit logs.</p>

            <div style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f7fafc', borderBottom: '2px solid #edf2f7', color: '#4a5568' }}>
                            <th style={{ padding: '15px' }}>Ticket ID</th>
                            <th style={{ padding: '15px' }}>Subject</th>
                            <th style={{ padding: '15px' }}>Agent</th>
                            <th style={{ padding: '15px' }}>Rating</th>
                            <th style={{ padding: '15px' }}>Customer Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tickets.length === 0 ? (
                            <tr><td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#a0aec0' }}>No records found for this metric.</td></tr>
                        ) : (
                            tickets.map(t => (
                                <tr 
                                    key={t.id}
                                    onClick={() => navigate(`/support?ticketId=${t.id}`)}
                                    style={{ borderBottom: '1px solid #edf2f7', cursor: 'pointer', transition: 'background-color 0.2s' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#ebf8ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    <td style={{ padding: '15px', fontWeight: 'bold', color: '#2b6cb0' }}>{t.ticketId}</td>
                                    <td style={{ padding: '15px', color: '#2d3748' }}>{t.subject}</td>
                                    <td style={{ padding: '15px', color: '#718096' }}>{t.assignedTo?.name || 'Unassigned'}</td>
                                    <td style={{ padding: '15px' }}>
                                        <div style={{ display: 'flex', color: (t.feedback?.rating || 0) >= 4 ? '#d69e2e' : '#e53e3e' }}>
                                            {'★'.repeat(t.feedback?.rating || 0)}{'☆'.repeat(5 - (t.feedback?.rating || 0))}
                                        </div>
                                    </td>
                                    <td style={{ padding: '15px', color: '#4a5568', fontStyle: 'italic', maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {t.feedback?.comments || '--'}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}